const WHATSAPP_NUMBER = '96170412000';

export function buildWhatsAppOrderUrl(product) {
    const message = `Hi, I'm interested in this item:\nID: ${product.item_id}\nName: ${product.item_name}`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function buildWhatsAppCartUrl(cartList) {
    const lines = cartList.map((item) => {
        const quantity = item.quantity || 1;
        return `ID: ${item.item_id} - ${item.item_name} x${quantity}`;
    });
    const message = `Hi, I'm interested in ordering these items:\n${lines.join('\n')}`;
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
